<p-messages
    severity="secondary"
    *ngIf="onboardingStatus?.current_status === onboardingStatusEnum.IN_PROGRESS"
    [enableService]="false"
    class="m-0 mt-4">
    <ng-template pTemplate>
        <div class="mr-3">
            <fa-icon [icon]="['far', 'spinner']" [pulse]="true" size="lg"></fa-icon>
        </div>
        <div class="flex-grow-1">
            <h6 class="m-0">{{ 'portal.dashboard.synchronizing-data' | translate }}</h6>
            <p class="small m-0">{{ 'portal.dashboard.synchronizing-data-message' | translate }}</p>
        </div>
    </ng-template>
</p-messages>
